import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const progressContainer = {
  position: 'absolute',
  height: '100%',
  top: 0,
  right: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#323643',
  opacity: 0.9,
  textAlign: 'center',
  zIndex: 1301,
};

const progressStyle = {
  zIndex: 1302,
};

const FullScreenCircularLoader = () => (
  <div style={progressContainer}>
    <CircularProgress color="secondary" style={progressStyle} />
  </div>
);

export default FullScreenCircularLoader;
